import { render, staticRenderFns } from "./OperatingRegions.vue?vue&type=template&id=fa61311a&"
import script from "./OperatingRegions.vue?vue&type=script&lang=js&"
export * from "./OperatingRegions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports